// The single horizontal/vertical gesture arbiter (Drive doc 12a). Shipped
// rule preserved from StackOverlay: vertical wins only when |dy| is strictly
// greater — a tie keeps the horizontal gesture alive.

export type GestureAxis = "horizontal" | "vertical" | "undecided";

export const GESTURE_COMMIT_PX = 10;

export const resolveGestureAxis = (
  deltaX: number,
  deltaY: number,
  commitPx: number = GESTURE_COMMIT_PX,
): GestureAxis => {
  const absX = Math.abs(deltaX);
  const absY = Math.abs(deltaY);
  // Shipped commit rule (StackOverlay): Manhattan distance beats the commit px.
  if (absX + absY <= commitPx) {
    return "undecided";
  }
  return absY > absX ? "vertical" : "horizontal";
};
